import { render, staticRenderFns } from "./assignarchivalmodal.vue?vue&type=template&id=978af68a&scoped=true&"
import script from "./assignarchivalmodal.vue?vue&type=script&lang=js&"
export * from "./assignarchivalmodal.vue?vue&type=script&lang=js&"
import style0 from "./assignarchivalmodal.vue?vue&type=style&index=0&id=978af68a&prod&lang=scss&scoped=true&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978af68a",
  null
  
)

export default component.exports